<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:items="revisoes"
			:headers="colunas"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #item.nomeAtividade="{ item }">
				<texto-tooltip :texto="item.nomeAtividade" :tamanho-maximo="50"></texto-tooltip>
			</template>
			<template #item.tipoEntidade="{ item }">
				<span>{{ getTipoEntidade(item.tipoEntidade) }}</span>
			</template>
			<template #item.encaminhamentoAutomatico="{ item }">
				<span> {{ getOpcaoSimNao(item.encaminhamentoAutomatico) }} </span>
			</template>
			<template #item.nomeAtividadeEncaminhamento="{ item }">
				<texto-tooltip
					v-if="item.nomeAtividadeEncaminhamento"
					:texto="item.nomeAtividadeEncaminhamento"
					:tamanho-maximo="50"
				></texto-tooltip>
				<span v-else>---</span>
			</template>
			<template #item.assinaturaAutomatica="{ item }">
				<span> {{ getOpcaoSimNao(item.assinaturaAutomatica) }} </span>
			</template>
			<template #item.juntarAutomatico="{ item }">
				<span> {{ getOpcaoSimNao(item.juntarAutomatico) }} </span>
			</template>
			<template #item.acoes="{ item }">
				<revisoes-listagem-botoes-acoes
					:item="item"
					@editar="editar"
					@excluir="excluir"
					@visualizar="visualizar"
				></revisoes-listagem-botoes-acoes>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
		<template-listagem-vazia :total-itens="totalItens" :textos="textoListagemVazia"></template-listagem-vazia>

		<modal-excluir-revisao
			:exibir="exibirModalExclusaoRevisao"
			@fechar-modal="abrirOuFecharModalExclusaoRevisao"
			@confirmar-exclusao-revisao="confirmarExclusaoRevisao"
		></modal-excluir-revisao>

		<modal-editar-revisao
			:exibir="exibirModalEdicaoRevisao"
			@fechar-modal="abrirOuFecharModalEdicaoRevisao"
			@confirmar-edicao-revisao="confirmarEdicaoRevisao"
		></modal-editar-revisao>
	</div>
</template>

<script>
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, opcaoSimNao, routesNames, situacoesRevisao } from '@/core/constants'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import RevisoesListagemBotoesAcoes from '@/views/pages/configuracao/revisoes/listagem/botoes-acoes/RevisoesListagemBotoesAcoes.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import ModalExcluirRevisao from '@/views/pages/configuracao/revisoes/listagem/modal-excluir-revisao/ModalExcluirRevisao.vue'
import ModalEditarRevisao from '@/views/pages/configuracao/revisoes/listagem/modal-editar-revisao/ModalEditarRevisao.vue'

export default {
	name: 'revisoes-listagem',
	components: {
		ModalEditarRevisao,
		ModalExcluirRevisao,
		TextoTooltip,
		RevisoesListagemBotoesAcoes,
		TemplateListagemVazia,
		PaginacaoTabela,
	},
	mixins: [tabelaMixin],
	props: {
		revisoes: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Tipo', 'tipo', '10%'),
				new TabelaColunaUtils('Fluxo', 'tipoEntidade', '10%'),
				new TabelaColunaUtils('Atividade', 'nomeAtividade', '10%'),
				new TabelaColunaUtils('Perfil', 'nomePerfil', '10%'),
				new TabelaColunaUtils('Encaminhamento Automático', 'encaminhamentoAutomatico', '15%'),
				new TabelaColunaUtils('Atividade Encaminhamento', 'nomeAtividadeEncaminhamento', '15%'),
				new TabelaColunaUtils('Assinatura Automática', 'assinaturaAutomatica', '10%'),
				new TabelaColunaUtils('Juntar Automático', 'juntarAutomatico', '10%'),
				new TabelaColunaUtils('Ações', 'acoes', '10%'),
			],
			textoListagemVazia: {
				titulo: 'Nenhuma revisão foi encontrada',
			},
			paginacaoInterna: this.paginacao,
			exibirModalExclusaoRevisao: false,
			idRevisaoExclusao: null,
			exibirModalEdicaoRevisao: false,
			idRevisaoEdicao: null,
		}
	},
	methods: {
		getOpcaoSimNao(opcao) {
			return opcaoSimNao[opcao].text
		},
		async resetarPage() {
			await this.$emit('resetar-page')
			await this.$emit('recarregar-listagem-revisoes')
		},
		abrirOuFecharModalExclusaoRevisao() {
			this.exibirModalExclusaoRevisao = !this.exibirModalExclusaoRevisao
		},
		abrirOuFecharModalEdicaoRevisao() {
			this.exibirModalEdicaoRevisao = !this.exibirModalEdicaoRevisao
		},
		editar(revisao) {
			this.idRevisaoEdicao = revisao.id
			if (revisao.situacao === 'FINALIZADO') {
				this.abrirOuFecharModalEdicaoRevisao()
			} else {
				this.redirecionarParaEdicao()
			}
		},
		redirecionarParaEdicao() {
			this.$router.push({
				name: routesNames.CONFIGURACAO.REVISOES.REVISOES_EDICAO_VIEW,
				params: { id: this.idRevisaoEdicao },
			})
		},
		async excluir(idRevisao) {
			this.idRevisaoExclusao = idRevisao
			this.abrirOuFecharModalExclusaoRevisao()
		},
		async confirmarExclusaoRevisao() {
			await this.$store.dispatch(actionTypes.CONFIGURACAO.REVISOES.EXCLUIR_REVISAO, this.idRevisaoExclusao)
			this.idRevisaoExclusao = null
			this.mostrarNotificacaoSucessoDefault()
			this.abrirOuFecharModalExclusaoRevisao()
			await this.resetarPage()
		},
		async confirmarEdicaoRevisao() {
			await this.$store.dispatch(actionTypes.CONFIGURACAO.REVISOES.ALTERAR_SITUACAO_REVISAO, {
				idRevisao: this.idRevisaoEdicao,
				body: {
					situacao: situacoesRevisao.EM_ELABORACAO.value,
				},
			})
			this.redirecionarParaEdicao()
		},
		visualizar(idRevisao) {
			this.$router.push({
				name: routesNames.CONFIGURACAO.REVISOES.REVISOES_VISUALIZACAO_VIEW,
				params: { id: idRevisao },
			})
		},
		getTipoEntidade(tipoEntidade) {
			const tiposEntidade = {
				ADESAO: 'Adesão',
				ADESAO_EXTERNA: 'Adesão Externa',
				PEDIDO_UTILIZACAO: 'Pedido Utilização',
			}

			return tiposEntidade[tipoEntidade]
		},
	},
}
</script>
